// SortItem factory and utilities
import type { SortItem } from './types';

export class SortItemFactory {
  static create(value: number, originalIndex: number): SortItem {
    return {
      id: `item-${originalIndex}`,
      value,
      originalIndex,
      currentIndex: originalIndex,
      status: 'idle'
    };
  }

  static createArray(values: number[]): SortItem[] {
    return values.map((value, index) => this.create(value, index));
  }

  static clone(item: SortItem): SortItem {
    return { ...item };
  }

  static verifyStability(input: SortItem[], output: SortItem[]): boolean {
    const inputPairs = input.map(item => ({ value: item.value, originalIndex: item.originalIndex }));
    const outputPairs = output.map(item => ({ value: item.value, originalIndex: item.originalIndex }));
    
    for (let i = 0; i < outputPairs.length - 1; i++) {
      if (outputPairs[i].value > outputPairs[i + 1].value) {
        return false;
      }
      if (outputPairs[i].value === outputPairs[i + 1].value && 
          outputPairs[i].originalIndex > outputPairs[i + 1].originalIndex) {
        return false;
      }
    }
    return true;
  }
}
